<div class="container-fluid">
  <div class="row">
    <div class="add-students-to-group-panel">
      <div class="top-div">
        <h1 class="main-title" *ngIf="action == 'ADD STUDENTS'">
          Add to Group
        </h1>
        <h1 class="main-title" *ngIf="action != 'ADD STUDENTS'">
          Remove from Group
        </h1>
        <div>
          <p
            *ngIf="
              (selectedGroup ||
                (groupsForDropdown && groupsForDropdown.length > 0)) &&
              students && students.length > 0
            "
            class="title-description"
          >
            You selected {{ students.length }} student{{
              students.length != 1 ? "s" : ""
            }}
            to {{ action == "ADD STUDENTS" ? "add to" : "remove from" }} a
            group.
            <ng-container *ngIf="action == 'ADD STUDENTS'">
              Don't worry, students already in the group will only be added
              once.
            </ng-container>
            <ng-container *ngIf="action == 'REMOVE STUDENTS'">
              Don't worry, removing students only takes them out of this group
              if they were in it already. You can still view them on the
              dashboard by clearing the group.
            </ng-container>
          </p>
          <p
            *ngIf="
              !selectedGroup &&
              (!groupsForDropdown || groupsForDropdown.length < 1)
            "
          >
            You have not created any student intervention groups. Please create
            a group before adding or removing students.
          </p>
          <p
            *ngIf="
              (selectedGroup ||
                (groupsForDropdown && groupsForDropdown.length > 0)) &&
              (!students || (students && students.length == 0))
            "
          >
            <ng-container *ngIf="action == 'ADD STUDENTS'">
              You must select students before you can add them to a group.
            </ng-container>
            <ng-container *ngIf="action != 'ADD STUDENTS'">
              You must select students before you can remove them from a group.
            </ng-container>
          </p>
        </div>
        <ng-select
          [items]="groupsForDropdown"
          bindLabel="name"
          [(ngModel)]="selectedGroup"
          placeholder="- Select a group -"
          [clearable]="false"
          [searchable]="false"
          class="group-select"
          *ngIf="
            groupsForDropdown &&
            groupsForDropdown.length > 0 &&
            students &&
            students.length > 0
          "
        ></ng-select>
      </div>

      <div
        class="group-details-panel"
        *ngIf="selectedGroup && students && students.length > 0"
      >
        <p
          class="group-name"
          *ngIf="!groupsForDropdown || groupsForDropdown.length < 1"
        >
          {{ selectedGroup.name }}
        </p>
        <p class="heading-title">{{ selectedGroup.name }} Description</p>
        <p class="group-value">
          <span *ngIf="selectedGroup.description">{{
            selectedGroup.description
          }}</span>
          <span class="no-group-value" *ngIf="!selectedGroup.description"
            >No description available</span
          >
        </p>
        <div
          *ngIf="
            data.columns &&
            selectedGroup &&
            selectedGroup.efficacyCriteria.length > 0
          "
          class="group-value"
        >
          <p class="heading-title">Criteria</p>
          <p
            *ngFor="let filterCol of selectedGroup.efficacyCriteria"
            class="add-remove-students-criteria-display-text"
          >
            {{ getColName(filterCol.student_kpi_id)
            }}<!----><span
              *ngIf="
                getColName(filterCol.student_kpi_id) !=
                metricRemovedFromDashboardText
              "
              >:
              <criteria-display-text
                [column]="getColumn(filterCol.student_kpi_id)"
                [criteria]="filterCol"
                class="add-remove-students-criteria-display-text"
              ></criteria-display-text>
            </span>
          </p>
        </div>
        <div
          *ngIf="
            selectedGroup.sharedWithAdmins ||
            selectedGroup.sharedWithSchoolLeadersAtSchoolIds.length > 0 ||
            selectedGroup.sharedWithTeachersAtSchoolIds.length > 0
          "
        >
          <p class="heading-title">Shared With Others</p>
          <p class="group-value" *ngIf="action == 'ADD STUDENTS'">
            This group has been shared with others. When you add students to a
            group, collaborators will be able to see them if and only if they
            have already been granted access to view a student's data by your
            district administrator.
          </p>
          <p class="group-value" *ngIf="action != 'ADD STUDENTS'">
            This group has been shared with others. When you remove students
            from a group, collaborators will not see them in the group.
          </p>
        </div>
      </div>

      <div class="error-panel" *ngIf="students && students.length > 0">
        <p class="help-text error-text" *ngIf="error">
          Action failed: contact
          <a
            href="https://illuminate.zendesk.com/hc/en-us/requests/new?ticket_form_id=21621854042395"
            target="_blank"
            title="Support"
            class="support-link"
            >support</a
          >
          for assistance.
        </p>
      </div>

      <div class="button-panel">
        <button
          mat-raised-button
          class="cancel-button"
          (click)="closeModal()"
          alt="Close modal"
        >
          CANCEL
        </button>
        <button
          mat-raised-button
          class="save-button"
          (click)="addToGroup()"
          alt="Add to Group"
          *ngIf="
            selectedGroup &&
            action == 'ADD STUDENTS' &&
            students &&
            students.length > 0
          "
        >
          ADD TO GROUP
        </button>
        <button
          mat-raised-button
          class="save-button"
          (click)="removeFromGroup()"
          alt="Remove from Group"
          *ngIf="
            selectedGroup &&
            action != 'ADD STUDENTS' &&
            students &&
            students.length > 0
          "
        >
          REMOVE FROM GROUP
        </button>
      </div>
    </div>
  </div>
</div>
